import React, { FunctionComponent, useEffect, useState }  from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend,  Label } from 'recharts';
import '../../stations/Station.scss';
import { CustomizedAxisTick } from '../chartsPopUpConstants';
import moment from 'moment';
import { ONEDAY, getMaxFromSelectedFields, getMinFromSelectedFields } from 'src/store/common';

type MinTempRHProps = {
    all_dates: any[],
}
const CustomTooltip:FunctionComponent = (props:any) => {
  const {active, label,payload}=props;

  if (active && payload && payload.length) {
    return (
      <div id = "custom-tooltip" className="custom-tooltip" style={{backgroundColor: 'white', border: 'none !important', height: '4rem', width: '5rem'}}>
        <span className="month" style={{fontSize: '.75rem', paddingBottom: '0px', paddingTop:'0px', display:'block'}}>
        {moment(label).format("MMM DD, YYYY")}
        </span>
        <svg width="50" height="10" style={{display: 'block', marginTop: '5px'}}>
          <rect width="5" height="5" style={{fill:'#be0000'}}/>
          <text
            fontSize=".75rem"
            height="8"
            x={10}
            y={10}
          >
          {`${payload[0].value}`}
        </text>
        </svg>
        <svg width="50" height="11" style={{display: 'block', marginTop: '5px'}}>
          <rect width="5" height="5" style={{fill:'blue'}}/>
          <text
            fontSize=".75rem"
            height="8"
            x={10}
            y={10}
          >
          {`${payload[1].value}`}
        </text>
        </svg>
      </div>
    );
  }
  return null;
};

export const MinTempRH: React.FC<MinTempRHProps> = ({all_dates}) => {
  const [xTicks, setXTicks] = useState<number[]>([]);
  useEffect(()=>{
    if(all_dates.length>1){
      let ticks:number[]=[];

      if(ticks.length<1){
        let i = moment(all_dates[0].date).format('MMM DD');
        ticks.push(all_dates[0].date)
        let j=0;
        while(i !== moment(all_dates.at(-1).date).format('MMM DD')){          
          j=j+1;
          ticks.push(all_dates[0].date + j*ONEDAY)
          i = moment(all_dates[0].date + j*ONEDAY).format('MMM DD')
        }
        setXTicks(ticks)
      }
  
    }
  },[all_dates]);   
  
  return(
    <>
    {all_dates.length>1 &&(
        <LineChart
        width={375}
        height={180}
        data={all_dates}
        margin={{
          top: (10),
          right: 5,
          left: 5,
          bottom: 10,
        }}
      >
          <XAxis dataKey="date" interval={0} type="number" tick={<CustomizedAxisTick />} domain={[all_dates.at(-1).date, all_dates[0].date]} ticks={xTicks}/>          
          <YAxis yAxisId="left" 
            domain={[getMinFromSelectedFields(all_dates, ['tempObs', 'tempF'],5), getMaxFromSelectedFields(all_dates, ['tempObs', 'tempF'])]}
            style={{fontSize: '0.7rem',fontFamily: 'serif'}} 
            unit="°F" 
            axisLine={false}>
          <Label
            value="Temperature (°F)"
            position="insideLeft"
            angle={-90}
            fontSize={'0.7rem'}
            style={{ textAnchor: 'middle'}}
          />
          </YAxis>
          <YAxis yAxisId="right" orientation="right"
            domain={[getMinFromSelectedFields(all_dates, ['rhvalsObs', 'rhvalsF'],5), getMaxFromSelectedFields(all_dates, ['rhvalsObs', 'rhvalsF'])]}
            style={{fontSize: '0.7rem',fontFamily: 'serif'}} 
            unit="%" axisLine={false}>
          <Label
            value="Relative Humidity (%)"
            position="insideRight"
            angle={-90}
            fontSize={'0.7rem'}
            style={{ textAnchor: 'middle' }}
          />
          </YAxis>
          <Tooltip content={<CustomTooltip />} position={{ y: -5 }} />
          <Legend wrapperStyle={{fontSize:'0.7rem', top:'170px', width: '100%'}} iconType="plainline" iconSize={10}/>
          <Line name="Temperature" type="monotone" yAxisId ="left" dataKey="tempObs" stroke="#be0000" dot={ false} strokeWidth={2}/>
          <Line name="Temperature Forecast" type="monotone" yAxisId = "left" dataKey="tempF" stroke="#be0000" dot={false} strokeDasharray="5 5" strokeWidth={2}/>
          <Line name="RH" type="monotone" yAxisId ="right" dataKey="rhvalsObs" stroke="blue" dot={ false} strokeWidth={2}/>
          <Line name="RH Forecast" type="monotone" yAxisId = "right" dataKey="rhvalsF" stroke="blue" dot={false} strokeDasharray="5 5" strokeWidth={2}/>
        </LineChart>
    )
    }
    </>

  );
}